var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('barra-titulo',{attrs:{"titulo":"Manifestos","icone":"fa fa-road","itens":_vm.breadCrumb}}),_c('lista')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }